import React from "react"
import Soon from "../../../UI/Soon"

const Settings = () => {

    return (
        <Soon />
    )
}

export default Settings